'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var Cookies = require('js-cookie');
var setup = require('pobble-components/dist/setup');
var utils = require('pobble-components/dist/utils');
var cookies = require('pobble-components/dist/cookies');
var api = require('pobble-components/dist/api');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var setToken = function setToken(token) {
  return Cookies__default["default"].set('token', token, _objectSpread(_objectSpread({}, setup.COOKIE_SETTINGS), {}, {
    expires: 28 // Token is valid for 28 days in case user selected "Remember me"

  }));
};

var getToken = function getToken(token) {
  return Cookies__default["default"].get('token', token, setup.COOKIE_SETTINGS);
};

var unsetToken = function unsetToken() {
  return Cookies__default["default"].remove('token', setup.COOKIE_SETTINGS);
};
/**
 * Redirect user to auth in with ability to
 * return back after succesful sign in
 */


var redirectToAuth = function redirectToAuth() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      redirectUrl = _ref.redirectUrl,
      redirectBack = _ref.redirectBack,
      _ref$route = _ref.route,
      route = _ref$route === void 0 ? '' : _ref$route;

  var redirect = redirectBack && window.location.href !== "".concat(setup.URLS.APP, "/") ? window.location.href : redirectUrl; // Only set redirect url if it matches current domain

  if (redirect && utils.getPobbleEnv() === utils.getPobbleEnv(redirect)) cookies.AUTH_REDIRECT.set(redirect);
  window.location.replace("".concat(setup.URLS.APP, "/auth/").concat(route));
  return null;
};
/**
 * Redirect user to the platform after succesful login
 * Check if user has to be redirected to some specific place
 *  that was saved before auth redirect
 */


var redirectAfterAuth = function redirectAfterAuth() {
  var redirect = cookies.AUTH_REDIRECT.get(); // Only redirect to the same environmentt

  if (redirect && utils.getPobbleEnv() === utils.getPobbleEnv(redirect)) {
    cookies.AUTH_REDIRECT.remove();
    window.location.href = redirect;
  } else {
    /**
     * If user signed up from moderation LP redirect to moderation
     *  otherwise redirect to Pobble 365
     */
    api.apiClient.get('v3/me?include=account.signup_details').then(function (res) {
      var _res$data, _res$data$account;

      var origin = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$account = _res$data.account) === null || _res$data$account === void 0 ? void 0 : _res$data$account.signup_origin;

      if (origin === 'mod') {
        window.location.href = '/moderation';
      } else {
        window.location.href = '/lessons/prompt';
      }
    });
  }
};

exports.getToken = getToken;
exports.redirectAfterAuth = redirectAfterAuth;
exports.redirectToAuth = redirectToAuth;
exports.setToken = setToken;
exports.unsetToken = unsetToken;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/auth-helpers/index.js